import * as React from 'react'
import IconButton from "./IconButton";
import { WidgetMessengerEventType } from '../../../../types';
import { useSelector } from 'react-redux';
import { MessageHelper } from '../../../helpers';
import { AppState } from '../../../store';

const MaximizeToggleButton = () => {
  const maximized = useSelector<AppState>(state => state.application.maximized)

  const onClick = () => {
    MessageHelper.sendMessage({
      type: WidgetMessengerEventType.TOGGLE_WINDOW_SIZE
    })
  }

  return (
    <IconButton onClick={onClick}>
      {maximized && <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><path stroke="currentColor" strokeWidth="1.7" d="m1 1 5 5"></path><path stroke="currentColor" strokeWidth="1.75" d="M1.5 6.5h5v-5m3.5 8.502 5 5m-5.5-.5v-5h5"></path></svg>}
      {!maximized && <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><path stroke="currentColor" strokeWidth="1.7" d="m1.999 2 5 5"></path><path stroke="currentColor" strokeWidth="1.75" d="M6.499 1.5h-5v5m7.5 2.5 5 5m.5-4.5v5h-5"></path></svg>}
    </IconButton>
  )
}

export default MaximizeToggleButton